export enum LoadingThemeType {
  cogs = 'cogs',
  gooey = 'gooey',
  wave = 'wave',
  atom = 'atom',
  sticky = 'sticky',
  withText = 'withText',
}
